/// <reference path="../_references.ts"/>

module App.TemplateStore {

	export type TemplateType = 'Global' | 'Associated' | 'Proprietary';

	export class StoreTemplate {
		id: number;
		created: string;
		creator: string;
		favorited: boolean;
		packages: TemplateListPackage[];
		times_loaded: number;
		name: string;
		public: boolean;
		rating: { count: number, average: number };
		is_downloaded: boolean;

		templateType: TemplateType;
		constructor(data: StoreTemplate) {
			this.id = data.id;
			this.created = data.created;
			this.creator = data.creator;
			this.favorited = data.favorited;
			this.packages = data.packages;
			this.times_loaded = data.times_loaded;
			this.name = data.name;
			this.rating = data.rating;
			this.public = data.public;
			this.is_downloaded = data.is_downloaded;

			if(this.public) {
				this.templateType = 'Global';
			} else {
				this.templateType = 'Associated';
			}
		}
	}

	export type TemplateListPackage = {
		id: number;
		code: string;
		name: string;
	}

	export type TemplateDetails = {
		id: number,
		created: string,
		creator: string,
		favorited: boolean,
		packages: TemplateDetailPackage[],
		times_loaded: number,
		name: string
		public: boolean;
		rating: { count: number, average: number };
		is_downloaded: boolean;
	}

	export type TemplateDetailPackage = {
		id: number;
		services: TemplateDetailService[];
		banner: string;
		description: string;
		warranty: string;
		mode: 'admin' | 'regular' | 'whilehere' | 'itemized';
		code: string;
		name: string;
		index: number;
		prices: PackagePrices;
	}

	export type TemplateDetailService = {
		id: number;
		quantity: number;
		service: Service;
		index: number;
		code: string;
	}

	export type Service = {
		id: number;
		name: string;
		image: string;
		description: string;
		number: number;
		video_url: string;
		code: string;
		display_price: string;
		while_here_with_agreement: string;
		regular_with_agreement: string;
		while_here_with_out_agreement: string;
		regular_with_out_agreement: string;
	}

	export type DownloadTemplateOptions = {
		department: number;
		name?: string;
		favorited?: boolean;
	}

	export type PackagePrices = {
		itemized: ItemizedPricing;
		whilehere: WhileHerePricing;
		regular: RegularPricing;
	}

	export class PricingBase {
		regular: string;
		service: string;
		servicemonthly: string;
	}

	export type ItemizedPricing = {
		volume: string;
		whileheremonthly: string;
		whilehere: string;
		regularmonthly: string;
	}

	export class WhileHerePricing extends PricingBase {
		regularnormally: string;
		servicenormally: string;
	}

	export class RegularPricing extends PricingBase { }
}